import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { useBrand } from '../../contexts/BrandContext';
import { heroBenefits, trustMarks } from '../../data/site';
export function Hero() {
  const {
    brand
  } = useBrand();
  return <section className="bg-cream" data-id="element-39" data-mp="eqx1te8tb0ro">
      <div className="mx-auto max-w-shell px-6 pb-10 pt-12 md:px-8 md:pb-14 md:pt-20" data-id="element-40" data-mp="eplvp7rw9gxe">
        <div className="grid items-center gap-10 lg:grid-cols-[1.02fr_0.98fr] lg:gap-16" data-id="element-41" data-mp="apbh56q1di6x">
          <motion.div initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.45,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-42" data-mp="5ofib7kjkm8d">
            <h1 className="max-w-xl font-serif text-[2.75rem] font-bold leading-[1.02] tracking-tight text-ink sm:text-6xl lg:text-[4.25rem]" data-id="element-43" data-mp="3rxqg10k36yca">
              {brand.copy.heroTitle[0]}
              <br data-id="element-44" data-mp="1q4sjour3pnml" />
              {brand.copy.heroTitle[1]}
            </h1>
            <p className="mt-6 max-w-lg text-lg leading-relaxed text-ink-soft" data-id="element-45" data-mp="1mwccweoyjp1u">
              {brand.copy.heroSubhead}
            </p>

            <ul className="mt-8 flex flex-col gap-3" data-id="element-46" data-mp="1rwgte4pv8js2">
              {heroBenefits.map(benefit => <li key={benefit} className="flex items-center gap-3" data-id="element-47" data-mp="1cz7y4zxfyvv2">
                  <span className="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brick text-cream" data-id="element-48" data-mp="1hwzt62tduy3h">
                    <CheckIcon className="h-3 w-3" strokeWidth={3} data-id="element-49" data-mp="25nvgammw954e" />
                  </span>
                  <span className="text-base text-ink" data-id="element-50" data-mp="2akviunkjbpqr">{benefit}</span>
                </li>)}
            </ul>

            <div className="mt-8 flex flex-wrap items-center gap-3" data-id="element-51" data-mp="1vwhhkh2ro9cb">
              <Button to="/shop" size="lg" data-id="element-52" data-mp="20vc33qs4cc04">
                Explore care
              </Button>
              <Button to="/how-it-works" variant="secondary" size="lg" data-id="element-53" data-mp="2olg19imjfjjq">
                How it works
              </Button>
            </div>
            <p className="mt-4 text-sm text-ink-muted" data-id="element-54" data-mp="2tdpq0vbx2dkf">
              Takes about two minutes. You will not be charged to find out.
            </p>
          </motion.div>

          <motion.img initial={{
          opacity: 0,
          scale: 0.98
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} src={brand.images.hero} alt="A Republic member at home" className="aspect-[4/5] w-full rounded-brand object-cover lg:aspect-[4/4.4]" data-id="element-55" data-mp="2yad7am0hy2jt" />
        </div>
      </div>

      <div className="border-y border-ink/10 bg-cream-light" data-id="element-56" data-mp="2fi0zhjr2q92a">
        <ul className="mx-auto grid max-w-shell gap-6 px-6 py-6 sm:grid-cols-2 md:px-8 lg:grid-cols-4" data-id="element-57" data-mp="2aj7ukfpurqdq">
          {trustMarks.map(mark => <li key={mark.label} className="flex items-start gap-3" data-id="element-58" data-mp="26jpblphldpdj">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brick" strokeWidth={2.5} data-id="element-59" data-mp="21jb3k7fzqffi" />
              <span data-id="element-60" data-mp="1wjomto0yeh1y">
                <span className="block text-sm font-medium text-ink" data-id="element-61" data-mp="1wl9glbfg1vyr">{mark.label}</span>
                <span className="mt-0.5 block text-sm text-ink-muted" data-id="element-62" data-mp="c0umwi1jo8nt">{mark.detail}</span>
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}